import { OrderCreateCargo, OrderCreateCargoTotal } from 'schema'

export const DEFAULT_CARGO_ITEM = {
  type: OrderCreateCargo.type.CUSTOM,
  amount: 1
}

export const DEFAULT_CARGO_TOTAL_ITEM = {
  type: OrderCreateCargoTotal.type.CUSTOM
}
